import { integer, pgTable, primaryKey, timestamp } from "drizzle-orm/pg-core";
import { stepTypeKeyEnum, stepTypes } from "./stepTypes.js";
import { taskTypeKeyEnum, taskTypes } from "./taskTypes.js";
export const taskStepTypesLinks = pgTable("task_step_types_link", {
    createdAt: timestamp("created_at", { withTimezone: true }).defaultNow().notNull(),
    updatedAt: timestamp("updated_at", { withTimezone: true })
        .defaultNow()
        .notNull()
        .$onUpdate(() => new Date()),
    // Foreign keys using the key enums directly
    taskType: taskTypeKeyEnum("task_type")
        .references(() => taskTypes.key)
        .notNull(),
    stepType: stepTypeKeyEnum("step_type")
        .references(() => stepTypes.key)
        .notNull(),
    orderNumber: integer("order_number").notNull(),
}, (table) => [
    // Composite primary key - each (taskType, stepType) combination is unique
    primaryKey({ columns: [table.taskType, table.stepType] }),
]);
